<nb-layout>
    <nb-layout-header fixed>
      <div class="col-5 sideBarToggle">
        <div>
          <a (click)="toggleCompact()" class="sidebar-toggle toggleOver">
            <nb-icon icon="menu-2-outline"></nb-icon>
          </a>
        </div>
        <div class="col">
          <img class="img-logo" src="assets/img/VCA-Home.png" alt="GRUPO MURCHISON">
        </div>
      </div>
      <div class="col-7">
        <div class="header-container"> 
          <button nbButton status="basic" size="small" class="buttontzUsuario" [nbContextMenu]="itemsUsuario" nbContextMenuTrigger="hover">
            <nb-icon icon="person-outline"></nb-icon>{{nombreApellido}} - {{cliente}} - {{operador}}
          </button>
          <button nbTooltip="Cerrar Sesión" nbTooltipPlacement="bottom" nbButton status="basic" size="small" class="buttontz" (click)="cerrarSession()">
            <nb-icon icon="log-out-outline"></nb-icon>           
          </button>
        </div>
      </div>
      <span class="" style="position: fixed; bottom: 10px; font-size: 12px; margin: -10px; padding: 0px; color: white">
        {{v}}</span>
    </nb-layout-header>
    <nb-sidebar fixed style="color: white !important; background-color: #007749; background-image: url(./assets/img/login/background.png)">
      <nb-menu
        tag="menu"
        responsive="true"
        (click)="cambioEstadoToggleLogic($event)"
        autoCollapse
        [items]="menuOpciones">
      </nb-menu>
      <!-- <span style="position: fixed; bottom: 10px; font-size: 12px; margin: -10px; padding: 0px;">
        {{v}}</span> -->
      <div class="control-panel">
      </div>
    </nb-sidebar>
  <nb-layout-column (click)="clickPrincipal($event)" class="layoutColumn">
    <router-outlet></router-outlet>
  </nb-layout-column>
  </nb-layout>